import React, {Component, Fragment} from 'react';
import HeaderFooterHOC from '../HOC/HeaderFooterHOC';
import ZonneGrensContainer from './leaflet/ZonneGrensContainer';
import LegacyZonneGrensContainer from "./leaflet/LegacyZonnegrensContainer";

class Zonnegrens extends Component {
	constructor() {
		super();

		this.checkForIPad = this.checkForIPad.bind(this);
	}

	checkForIPad() {
        return !!(navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
    }

    componentDidCatch(error, errorInfo) {
        return false;
    }

	render() {
	    const isIos = parseInt(document.head.querySelector('meta[name="is_ios"]').content);
        const ZonnegrensComponent = (isIos === 1 || this.checkForIPad()) ? LegacyZonneGrensContainer : ZonneGrensContainer;
        const latLng = (this.props.latLng.length > 1) ? this.props.latLng.split(',') : false;

        return (
				<Fragment>
					{!!latLng && <ZonnegrensComponent latLng={this.props.latLng} height={this.props.building_height} theme={this.props.theme} />}

					{ this.props.page_content && <div dangerouslySetInnerHTML={{__html: this.props.page_content.page_content}} />}
				</Fragment>
		)
	}
}


export default HeaderFooterHOC(Zonnegrens, 'zonnegrens');


